<template>
  <v-dialog
    persistent
    max-width="500px"
    :value="show">
    <v-card class="px-4 pt-4 pb-4">
      <v-card-title>
        <h2>
          ¡Atención!
        </h2>
      </v-card-title>
      <v-card-text>
        <p>
          No se encontro el contacto asociado a un cliente, por lo que no se agrego a la lista negra.
        </p>
        <p>
          Te recomendamos buscarlo de manera manual en el modulo de clientes para invalidarlo, para ello debes tener en cuenta lo siguiente
        </p>
        <ul class="pl-3">
          <li class="mb-3">
            <p>
              Si el contacto del chat contiene mas de una palabra se debe buscar el cliente con punto separando las palabras
            </p>
            Ej.
            <ol class="pl-3">
              <li>
                Si el chat indica: joseperez@gmail.com
              </li>
              <li>
                Buscar en el modulo Ciente: jose.perez@gmail.com
              </li>
            </ol>
          </li>
          <li>
            <p>
              En caso contrario, se debe buscar el cliente colocando punto donde pueda haber un espacio
            </p>
            Ej.
            <ol class="pl-3">
              <li>
                Si el chat indica: jperez@gmail.com
              </li>
              <li>
                Buscar en el modulo Ciente: j.perez@gmail.com
              </li>
            </ol>
          </li>
        </ul>
      </v-card-text>
      <v-card-actions>
        <v-layout>
          <v-flex 12>
            <v-btn flat color="black" @click="$emit('close')">
              CERRAR
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/chat_center_v2/AlertModal.vue